<template>
    <section>
        <div v-if="loading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <div class="pres_wrap">
      <div class="pres_div">
        <a href="#" class="pres_link-block w-inline-block"><img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" alt="" class="pres_image"></a>
        <div class="pres_text-block">Confirm Prescription</div>
        <p class="pres_paragraph"><strong>Congrats! Your prescription has been approved.</strong> Please review your prescription details below to confirm everything is correct before we ship. If any changes are needed, click “Decline & Update with Doctor.” If we don’t hear from you within 12 hours, your order will be shipped as written.</p>
        <div class="pres_items-div" v-if="!loading">
          <div class="pres_item-box-div" v-for="item in prescriptionItems" :key="item.rxId">
            <div class="pres_upsell_productinfo_div">
              <div class="pres_choice-img-div">
                <img :src="getItemImage(item.name)" :alt="item.name" loading="lazy" class="pres_upsell_product_img">
              </div>
              <div class="pres_upsell-text-side-div">
                <div class="pres_upsell_productname_pricediv">
                  <div class="pres_progname-div">
                    <div class="pres_upsell-procuctname" style="font-size: 18px;">{{ cleanItemName(item.name) }}</div>
                    <div class="pres_upsell_productsub_div">
                      <img loading="lazy" src="images/icon_-RX-black.svg" alt="" class="pres_image-596">
                    </div>
                  </div>
                </div>
                <p class="pres_upsell_paragraph-copy">{{ item.directions }}</p>
              </div>
            </div>
          </div>
        </div>
       
        <a @click.prevent="handleApprove" class="pres_button w-button" :disabled="submitting">
          {{ submitting && actionType === 'approve' ? 'Processing...' : 'Approve' }}
        </a>
        <a @click.prevent="handleDeny" class="pres_link" :disabled="submitting">
          {{ submitting && actionType === 'deny' ? 'Processing...' : 'Decline & Update with Doctor' }}
        </a>
        <p class="pres_paragraph-2"></p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PrescriptionView',
  data() {
    return {
      prescriptionItems: [],
      loading: true,
      submitting: false,
      actionType: '',
      isLoading: false,
      baseUrl: process.env.VUE_APP_API_ENDPOINT
    }
  },
  
  computed: {
    ...mapGetters(['user']),
    
    prescriptionId() {
      return this.$route.params.id
    }
  },
  
  async created() {
    await this.fetchPrescription()
  },
  
  methods: {
    cleanItemName(itemName) {
      // Remove T1-T6 or S1-S5 patterns and any following comma from the item name
      return itemName.replace(/\b(T[1-6]|S[1-5])\b,?\s*/g, '').trim()
    },
    async fetchPrescription() {
      try {
        this.loading = true
        const response = await this.$axios.get(`${this.baseUrl}/api/prescription-pending/${this.prescriptionId}`)
        
        if (response.data.success && response.data.prescription) {
          // Filter out Ondansetron items
          this.prescriptionItems = response.data.prescription.filter(item => 
            !item.name.toLowerCase().includes('ondansetron')
          )
        }else{
            this.$router.push('/home');
        }
      } catch (error) {
        console.error('Error fetching prescription:', error)
        this.prescriptionItems = []
      } finally {
        this.loading = false
      }
    },
    
    getItemImage(itemName) {
      const name = itemName.toLowerCase()
      
      if (name.includes('tirzepatide')) {
        return 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/tirzepatide/1.webp'
      } else if (name.includes('semaglutide')) {
        return 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/semaglutide/1.webp'
      } else {
        // Default image for other medications
        return 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/default/1.webp'
      }
    },

    async handleApprove() {
      await this.updatePrescription(true)
    },

    async handleDeny() {
      await this.updatePrescription(false)
    },

    async updatePrescription(accept) {
      try {
        this.submitting = true
        this.actionType = accept ? 'approve' : 'deny'

        const response = await this.$axios.post(`${this.baseUrl}/api/prescription-update/${this.prescriptionId}`, {
          order_id: this.prescriptionId,
          accept: accept
        })

        if (response.data.success) {
          if (accept) {
            // On approve, redirect to home
            this.$router.push('/home')
          } else {
            // On deny, redirect to adjust doses page
            this.$router.push(`/adjust-doses/${this.prescriptionId}`)
          }
        } else {
          this.$router.push('/home');
        }
      } catch (error) {
        console.error('Error updating prescription:', error)
        // You might want to show an error message to the user here
      } finally {
        this.submitting = false
        this.actionType = ''
      }
    }
  }
}
</script>

<style scoped>
/* Remove duplicated font declarations and use inherited fonts */
.pres_wrap {
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  font-family: inherit;
}

.pres_div {
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  width: 600px;
  display: flex;
  font-family: inherit;
}

.pres_link-block {
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 50px;
  display: flex;
}

.pres_image {
  width: auto;
  height: 50px;
}

.pres_text-block {
  font-family: inherit;
  color: #000;
  text-align: center;
  margin-bottom: 15px;
  font-size: 38px;
  font-weight: 900;
  line-height: 50px;
}

.pres_paragraph {
  font-family: inherit;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
  font-size: 20px;
  line-height: 24px;
}

.pres_list {
  margin-bottom: 50px;
  padding-left: 15px;
}

.pres_text-block-2 {
  font-family: inherit;
  color: #000;
  font-size: 18px;
  line-height: 24px;
}

.pres_button {
  font-family: inherit;
  color: white;
  text-align: center;
  background-color: #2e9bf0;
  border: 1px #000;
  border-radius: 11px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 30px;
  padding-top: 26px;
  padding-bottom: 29px;
  font-size: 25px;
  font-weight: 900;
}

.pres_paragraph-2 {
  font-family: inherit;
  color: #000;
  text-align: center;
  width: 80%;
  font-size: 10px;
  line-height: 12px;
}

.pres_link {
  font-family: inherit;
  color: #000;
  margin-bottom: 30px;
  font-size: 16px;
}

.pres_link-block-95 {
  color: #000;
  background-color: #fff0;
  border: 1px solid #000;
  border-radius: 6px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 49%;
  font-family: inherit;
  text-decoration: none;
  display: flex;
}

.pres_link-block-95:hover {
  background-color: #c9e8ff;
}

.pres_price-2 {
  color: #000;
  font-size: 30px;
  font-weight: 900;
  line-height: 24px;
}

.pres_price-2.pres_old {
  font-size: 23px;
}

.pres_price-2.pres_old.pres_upsell {
  font-size: 20px;
  line-height: 25px;
}

.pres_upsell_benefits_div {
  justify-content: space-between;
  align-items: stretch;
  display: flex;
}

.pres_upsell_productinfo_div {
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
}

.pres_choice-main-div {
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
}

.pres_choice-box-flex {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.pres_upsell_details_div {
  margin-bottom: 20px;
  display: block;
}

.pres_item-price-div {
  align-items: flex-start;
  display: flex;
  position: relative;
}

.pres_image-596 {
  width: 20px;
  margin-right: 0;
}

.pres_upsell_boxtag {
  color: #000;
  background-color: #c9e8ff;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  margin-bottom: 15px;
  padding: 3px 8px;
  font-family: inherit;
  font-weight: 700;
  display: inline-block;
  position: absolute;
  inset: 0% 3% auto auto;
}

.pres_choice-box-div-1 {
  width: 100%;
}

.pres_div-block-2134 {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.pres_div-block-1948 {
  align-items: center;
  margin-bottom: 5px;
  display: flex;
}

.pres_upsell-bullet-text {
  color: #000;
  background-color: #c9e8ff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.pres_upsell-bullet-text.pres_no-highlight {
  background-color: #fff0;
  background-image: linear-gradient(#fff 70%, #e9ff86 70% 88%, #fff0 88%);
  font-weight: 700;
}

.pres_upsell-procuctname {
  font-family: inherit;
  color: #000;
  margin-bottom: 2px;
  font-size: 30px;
  font-weight: 900;
  line-height: 31px;
}

.pres_dollar-sign-2 {
  color: #000;
  font-weight: 900;
  line-height: 15px;
}

.pres_program-amount {
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 1px;
  font-family: inherit;
  display: flex;
}

.pres_text-block-728 {
  color: #333;
  font-family: inherit;
  font-size: 18px;
  font-weight: 800;
  line-height: 10px;
}

.pres_upsell-product-subtext {
  color: #999;
  margin-bottom: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.pres_text-block-1451 {
  margin-top: -1px;
  margin-bottom: 1px;
  font-size: 10px;
  font-weight: 900;
  line-height: 10px;
}

.pres_text-block-1452 {
  font-size: 13px;
  font-weight: 900;
  line-height: 10px;
}

.pres_choice-img-div {
  border-radius: 9px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: auto;
  padding: 5px;
  display: flex;
}

.pres_upsell_product_img {
  width: 95px;
  height: auto;
}

.pres_upsell-text-side-div {
  width: 80%;
  margin-left: 10px;
}

.pres_upsell_productsub_div {
  align-items: center;
  display: flex;
}

.pres_upsell_bullet_img {
  width: 18px;
  margin-right: 10px;
}

.pres_upsell_buttons-stack {
  flex-flow: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
  display: flex;
}

.pres_upsell-price-main-div {
  text-align: left;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
  margin-top: 7px;
  padding-top: 0;
  display: flex;
}

.pres_upsell-prices-div {
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.pres_x_img {
  width: 80%;
  position: absolute;
  inset: auto 0% 15% auto;
}

.pres_x_img.pres__2digit {
  bottom: 28%;
}

.pres_image-620 {
  background-color: #c9e8ff;
  border-radius: 99px;
  width: 20px;
}

.pres_upsell_bullets_div {
  width: 49.5%;
}

.pres_upsell-buy-button {
  color: #000;
  text-align: center;
  background-color: #e9ff86;
  border: 1px solid #000;
  border-radius: 9px;
  width: 100%;
  margin-bottom: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 18px;
  font-weight: 800;
  line-height: 11px;
  text-decoration: none;
}

.pres_upsell-buy-button:hover {
  background-color: #c9e8ff;
}

.pres_upsell_productname_pricediv {
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 5px;
  display: flex;
}

.pres_upsell_learnbutton {
  color: #000;
  text-align: center;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 6px;
  width: 49%;
  padding-left: 4px;
  padding-right: 4px;
  font-family: inherit;
  font-size: 14px;
}

.pres_upsell_learnbutton:hover {
  background-color: #f3f3f3;
}

.pres_upsell-box {
  border: 1px solid #000;
  border-radius: 13px;
  width: 100%;
  margin-bottom: 0;
  padding: 0;
  position: relative;
}

.pres_upsell-buttons-flex {
  justify-content: space-between;
  display: flex;
}

.pres_upsell-buttons-flex.pres_hide-buttons {
  display: none;
}

.pres_program-price {
  color: #000;
  margin-right: 0;
  font-family: inherit;
  font-size: 30px;
  font-weight: 900;
  line-height: 17px;
}

.pres_upsell_paragraph {
  color: #000;
  letter-spacing: -.5px;
  width: 80%;
  margin-bottom: 20px;
  font-family: inherit;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
}

.pres_upsell_paragraph-copy {
  color: #000;
  letter-spacing: -.5px;
  width: 100%;
  margin-bottom: 0;
  font-family: inherit;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
}

.pres_item-box-div {
  border: 1px solid #000;
  background-color: white;
  border-radius: 11px;
  width: 100%;
  padding: 10px;
}

.pres_items-div {
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 40px;
  display: flex;
}

.pres_progname-div {
  display: block;
}

@media screen and (max-width: 479px) {
  .pres_wrap {
    padding-left: 3%;
    padding-right: 3%;
  }

  .pres_div {
    width: 100%;
  }

  .pres_link-block {
    margin-bottom: 40px;
  }

  .pres_paragraph {
    margin-bottom: 30px;
  }

  .pres_button, .pres_paragraph-2 {
    width: 100%;
  }

  .pres_link-block-95 {
    color: #000;
    border: 1px solid #000;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    width: 49%;
    font-size: 12px;
    text-decoration: none;
    display: flex;
  }

  .pres_price-2 {
    font-size: 24px;
  }

  .pres_price-2.pres_old {
    font-size: 18px;
    line-height: 18px;
  }

  .pres_price-2.pres_old.pres_upsell {
    font-family: inherit;
    font-size: 14px;
  }

  .pres_upsell_benefits_div {
    justify-content: space-between;
    display: flex;
  }

  .pres_upsell_productinfo_div {
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 0;
    padding-top: 0;
  }

  .pres_upsell_details_div {
    flex-flow: column;
    justify-content: space-between;
    display: block;
  }

  .pres_div-block-2134 {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .pres_div-block-1948 {
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 6px;
  }

  .pres_upsell-bullet-text {
    font-size: 14px;
  }

  .pres_upsell-bullet-text.pres_no-highlight {
    background-image: none;
    margin-top: -2px;
  }

  .pres_upsell-procuctname {
    color: #000;
    font-size: 20px;
    font-weight: 900;
    line-height: 26px;
  }

  .pres_dollar-sign-2 {
    font-size: 10px;
    line-height: 15px;
  }

  .pres_upsell-product-subtext {
    color: #999;
    margin-bottom: 5px;
    font-weight: 900;
  }

  .pres_choice-img-div {
    width: 22%;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .pres_upsell_product_img {
    width: 95px;
  }

  .pres_upsell-text-side-div {
    width: 80%;
  }

  .pres_upsell_bullet_img {
    width: 15px;
    margin-right: 5px;
  }

  .pres_upsell_buttons-stack {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    flex-flow: column;
    width: 100%;
    margin-top: 15px;
  }

  .pres_x_img {
    width: 60%;
    inset: 8px 5% 0% auto;
  }

  .pres_image-620 {
    width: 20px;
  }

  .pres_upsell_bullets_div {
    width: 49.5%;
  }

  .pres_upsell-buy-button {
    width: 100%;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .pres_upsell_productname_pricediv {
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    margin-bottom: 2px;
  }

  .pres_upsell_learnbutton {
    width: 49%;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .pres_upsell-buttons-flex {
    justify-content: space-between;
    display: flex;
  }

  .pres_program-price {
    font-size: 30px;
    font-weight: 900;
    line-height: 20px;
  }

  .pres_upsell_paragraph {
    color: #000;
    width: 90%;
    margin-bottom: 15px;
    font-size: 16px;
  }

  .pres_upsell_paragraph-copy {
    color: #000;
    width: 100%;
    margin-bottom: 0;
    font-size: 15px;
    line-height: 18px;
  }

  .pres_item-box-div {
    padding: 8px 5px;
  }
}
</style>